module.exports = __webpack_public_path__ + "static/empty-states-linked-text-do-f13609bcf747580a83126a7e0924340a.png";